module.exports = __webpack_public_path__ + "img/source1_1.9c170d24.png";